export default __webpack_public_path__ + "static/media/QSGRW_Cycle.4308bfbd.png";